import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "color-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_app_color_mask = _resolveComponent("app-color-mask")!
  const _component_app_tab = _resolveComponent("app-tab")!
  const _component_app_collage = _resolveComponent("app-collage")!
  const _component_app_tabs = _resolveComponent("app-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_app_tabs, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_tab, { title: "mask" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_color_mask, {
              onIsLoading: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isLoading = $event))
            })
          ]),
          _: 1
        }),
        _createVNode(_component_app_tab, { title: "collage" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_collage, {
              onIsLoading: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isLoading = $event))
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}